export default __webpack_public_path__ + "static/media/Ben-10-logo.8bba80df.png";